import * as React from 'react'
import styled from 'styled-components'
import { media } from 'src/utils.js'
import CustomModal from 'src/components/containers/CustomModal'
import { Col, Row } from 'react-bootstrap'
import { inject } from 'mobx-react'
import { StoreProps } from 'src/stores'
import Link from 'src/components/atoms/input/buttons/Link'

const stefan = require('src/assets/redesign/Stefan_Atz.png')

interface Props extends StoreProps {
  open: boolean
  onClose: () => void
}

interface State {
  showCopyLink: boolean
  copySuccessful: boolean
}

@inject('confStore')
export default class ModalClientDetails extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { showCopyLink: false, copySuccessful: false }
  }

  dataLine = (key, value) => {
    return (
      <Row>
        <Col xs={3}>
          <p style={{ textAlign: 'left' }}>{key}</p>
        </Col>
        <Col xs={9}>
          <p style={{ textAlign: 'right' }}>{value}</p>
        </Col>
      </Row>
    )
  }

  planningReasonName = (planningReason) => {
    switch (planningReason) {
      case 'ACUTE_BEREAVEMENT':
        return 'Eingetretener Trauerfall'
      case 'IMPENDING_BEREAVEMENT':
        return 'Bevorstehender Trauerfall'
      case 'PROVISION':
        return 'Bestattungsvorsorge'
      default:
        return 'Ungültig!'
    }
  }

  share = () => {
    // TODO with the next version of Typescript
    // this workaround should no longer be necessary
    const workaround: any = navigator
    if (workaround.share) {
      workaround.share({
        name: 'Bestattungsplanung | Benu',
        url: location.href,
        text: 'Meine Bestattungsplanung bei Benu'
      })
    } else {
      this.setState({ showCopyLink: true })
    }
  }

  copyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(location.href).then(
        () => {
          this.setState({ copySuccessful: true })
        },
        (err) => {
          console.error('Async: Could not copy text: ', err)
        }
      )
    }
  }

  closeSelf = () => {
    const { onClose } = this.props
    onClose()
    this.setState({ copySuccessful: false, showCopyLink: false })
  }

  render() {
    const { open, confStore } = this.props
    const { showCopyLink, copySuccessful } = this.state
    return (
      <CustomModal
        open={open}
        onClose={this.closeSelf}
        title='Ihr Angebot'
        cancelX
        hideCloseButton>
        {this.dataLine(
          'Anliegen:',
          this.planningReasonName(confStore.getOffer.planningReason)
        )}
        {this.dataLine('Angebot:', confStore.getOffer.orderId)}
        {this.dataLine('Datum:', confStore.getOffer.creationDate)}
        {this.dataLine('Ort:', confStore.getOffer.location.label ? confStore.getOffer.location.label : confStore.getOffer.location.city)}
        {showCopyLink ? (
          <div style={{ margin: '0 7.5px' }}>
            <p
              style={{
                overflowX: 'scroll',
                overflowY: 'hidden',
                borderBottom: '2px solid #A7C9CD',
                padding: '3px',
                maxHeight: '30px',
                whiteSpace: 'nowrap'
              }}>
              {location.href}
            </p>
            {copySuccessful ? (
              <p style={{ marginBottom: '0' }}>Link kopiert!</p>
            ) : (
              <a onClick={this.copyLink}>Link kopieren</a>
            )}
          </div>
        ) : (
          <Link onClick={this.share}>
            <i className='fas fa-share-alt' /> Planung teilen
          </Link>
        )}
        <p style={{ fontWeight: 'bold', fontSize: 17, textAlign: 'left' }}>
          Kontaktdaten
        </p>
        {this.dataLine(
          'Name:',
          `${confStore.getOffer.contactDetails.firstName} ${confStore.getOffer.contactDetails.lastName}`
        )}
        {this.dataLine('E-Mail:', confStore.getOffer.contactDetails.email)}
        {this.dataLine('Telefon:', confStore.getOffer.contactDetails.phone)}
        <p style={{ fontWeight: 'bold', fontSize: 17, textAlign: 'left' }}>
          Ansprechperson
        </p>
        {this.dataLine('Name:', 'Stefan Atz')}
        {this.dataLine('E-Mail:', 'kontakt@benu.at')}
        {this.dataLine('Telefon:', '0800 88 44 04')}
        <StefanContainer>
          <ProfilePicture
            src={stefan}
            height={90}
            width={90}
            alt='Stefan Atz'
          />
          <p>
            <i>
              „Mein Team an Bestattungs&shy;experten und ich kümmern uns
              persönlich um alle Ihre Anliegen.”
            </i>
            <br />
            <br />
            <strong>Stefan Atz</strong>
            <br />
            <i>(Geschäftsführer)</i>
          </p>
        </StefanContainer>
        <Link onClick={this.closeSelf}> ZURÜCK </Link>
      </CustomModal>
    )
  }
}

const StefanContainer = styled.div`
  display: flex;
  flex-direct: row;
  align-items: center;
  width: 100%;
  margin: 15px 0;
  padding: 7.5px 15px;
  background: #d5e4e6;

  * {
    margin: 15px;
  }

  p {
    line-height: 1.15;
    * {
      margin: 0;
    }
  }
  ${media.phone`
    flex-direction: column;
    p {
      margin-top: 0;
      text-align: center;
    }
  `}
`

const ProfilePicture = styled.img`
  display: block;
  margin: 15px auto;
  border-radius: 100%;
  flex-shrink: 0;
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ModalClientDetails.tsx